/* eslint-disable react/prop-types */
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";

const ProcessLogs = (props: any) => {
  const { logsData } = props;

  const renderSteps = (rowData: any) => {
    return (
      <>
        <ul className="mt-4 divide-y divide-dashed">
          {rowData?.steps.map((item: any, index: number) => (
            <>
              <li key={index} className="text-sm w-full flex flex-row  py-1">
                <span>{item.message} - </span>
                <span className=" text-ellipsis overflow-hidden px-1">
                  {item.code}
                </span>
              </li>
            </>
          ))}
        </ul>
      </>
    );
  };

  const renderStartTime = (rowData: any) => {
    return <>{moment(rowData.startTime).format("MM/DD/YYYY HH:mm a")}</>;
  };

  const renderEndTime = (rowData: any) => {
    return <>{moment(rowData.endTime).format("MM/DD/YYYY HH:mm a")}</>;
  };

  return (
    <>
      <DataTable
        className="shadow-md"
        scrollHeight="300px"
        value={logsData}
        stripedRows
        dataKey="id"
        paginator={true}
        filterDisplay="menu"
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rowsPerPageOptions={[10, 20, 50, 100]}
        emptyMessage="No Reports found."
        totalRecords={logsData.length}
        rows={10}
        style={{ fontSize: 13 }}
      >
        <Column
          field="previousStatus"
          header="Previous Status"
          style={{ width: "15%" }}
        ></Column>
        <Column
          field="currentStatus"
          header="Current Status"
          style={{ width: "15%" }}
        ></Column>
        <Column
          body={renderStartTime}
          header="Start Time"
          style={{ width: "15%" }}
        ></Column>
        <Column
          body={renderEndTime}
          header="End Time"
          style={{ width: "15%" }}
        ></Column>
        <Column
          body={renderSteps}
          header="Process Flow"
          style={{ width: "55%" }}
        ></Column>
      </DataTable>
    </>
  );
};

export default ProcessLogs;
